<div class="sn-modal__inner-wrap" *ngIf="isHiddenMode || isShowModal" [hidden]="isHiddenMode && !isShowModal">
  <div class="sn-modal__container">
    <div class="slds-modal__header">
      <!--header-->
      <ng-content select=".sn-modal-header"></ng-content>
    </div>
    <div class="slds-modal__content slds-p-around_medium max-height-455">
      <!--body content-->
      <ng-content select=".sn-modal-content"></ng-content>
    </div>
    <div class="slds-modal__footer">
      <!--footer content for button etc-->
      <ng-content select=".sn-modal-footer"></ng-content>
    </div>
  </div>

  <div class="sn-modal__backdrop"></div>
</div>
